import script from "./aside.vue?vue&type=script&setup=true&lang=js"
export * from "./aside.vue?vue&type=script&setup=true&lang=js"

import "./aside.vue?vue&type=style&index=0&id=2d7707a7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.21_vue@3.2.39_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d7707a7"]])

export default __exports__